import React from "react";
import { styled } from "@mui/material";
import PrimaryButton from "../generated/PrimaryButton";
import MobileUswfButton from "./mobile/MobileUswfButton";

const UswfButton = styled(PrimaryButton)({
  minWidth: 300,
  paddingLeft: 16,
  paddingRight: 16,
});

const ComboButton = (props) => (
  <>
    <UswfButton
      {...props}
      className={
        props.className
          ? `desktop-uswf-button ${props.className}`
          : "desktop-uswf-button"
      }
    />
    <MobileUswfButton
      {...props}
      className={
        props.className
          ? `mobile-uswf-button ${props.className}`
          : "mobile-uswf-button"
      }
    />
  </>
);
export default ComboButton;
